class ProductItem extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      productMediaTemplate: "[js-quick-view-media-template]",
      quickShopButton: "[js-quick-shop-button]",
      swatchImages: "[js-product-item-swatch-image]",
      swatches: "[js-swatch]",
      swatchOverflowButton: "[js-product-listing-swatch-overflow]",
    };

    this.classes = {
      active: "active",
      swatchActive: "swatch-active",
      selectedSwatch: "swatch--selected",
    };
  }

  connectedCallback() {
    this.controller = new AbortController();

    // Quick shop
    this.quickShopButton = this.querySelector(this.selectors.quickShopButton);

    // Swatches
    this.swatchImages = this.querySelectorAll(this.selectors.swatchImages);
    this.swatches = this.querySelectorAll(this.selectors.swatches);
    this.swatchOverflowButton = this.querySelector(this.selectors.swatchOverflowButton);

    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", this.handleSwatchClick.bind(this), {
        signal: this.controller.signal,
      });
    });

    if (this.swatchOverflowButton && this.quickShopButton) {
      this.swatchOverflowButton.addEventListener(
        "click",
        this.handleSwatchOverflowClick.bind(this),
        { signal: this.controller.signal }
      );
    }

    // Mobile slider
    this.initSlider();
  }

  handleSwatchClick(event) {
    const swatch = event.currentTarget;

    if (swatch.classList.contains(this.classes.selectedSwatch)) {
      swatch.classList.remove(this.classes.selectedSwatch);
      this.classList.remove(this.classes.swatchActive);

      this.swatchImages.forEach((img) => {
        if (img.dataset.swatchValue === swatch.dataset.value) {
          img.classList.remove(this.classes.active);
        }
      });

      return;
    }

    this.swatchImages.forEach((img) => img.classList.remove(this.classes.active));
    this.swatches.forEach((s) => s.classList.remove(this.classes.selectedSwatch));

    swatch.classList.add(this.classes.selectedSwatch);

    let found = false;

    this.swatchImages.forEach((img) => {
      if (img.dataset.swatchValue === swatch.dataset.value) {
        img.classList.add(this.classes.active);
        this.classList.add(this.classes.swatchActive);
        found = true;
      }
    });

    if (!found) this.classList.remove(this.classes.swatchActive);
  }

  handleSwatchOverflowClick() {
    this.openQuickView();
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  // ----------------------------------------
  // MOBILE SLIDER
  // ----------------------------------------
 initSlider() {
  const slider = this.querySelector("[js-slider]");
  if (!slider) return;

  const track = slider.querySelector("[js-slider-track]");
  const dotsContainer = this.querySelector("[js-slider-dots]");  // FIX QUI
  const slides = track.children;

  if (!track || !dotsContainer || slides.length === 0) return;

  let index = 0;
  let startX = 0;
  let currentX = 0;

  // Create dots
  dotsContainer.innerHTML = ""; // sicurezza
  for (let i = 0; i < slides.length; i++) {
    const dot = document.createElement("button");
    dot.type = "button";
    if (i === 0) dot.classList.add("active");
    dot.addEventListener("click", () => {
      index = i;
      updateSlider();
    });
    dotsContainer.appendChild(dot);
  }

  const dots = dotsContainer.querySelectorAll("button");

  const updateSlider = () => {
    track.style.transform = `translateX(-${index * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle("active", i === index));
  };

  // Touch logic
  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    currentX = startX;
  }, { passive: true });

  track.addEventListener("touchmove", (e) => {
    currentX = e.touches[0].clientX;
  }, { passive: true });

  track.addEventListener("touchend", () => {
    const diff = currentX - startX;

    if (diff > 50 && index > 0) index--;
    else if (diff < -50 && index < slides.length - 1) index++;

    updateSlider();
  });
}

}

if (!customElements.get("product-item")) {
  customElements.define("product-item", ProductItem);
}

